// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tilt } from 'react-tilt';

import { CardBlur } from 'components';
import FadeInSection from 'components/FadeInSection';

import { Container, StyledButton, Wrapper } from './styles';
import { ReactComponent as Bg } from 'assets/icons/black_level_1.svg';
import BgMobile from 'assets/images/showcase/black-mobile.png';
import CloseUp from 'assets/images/showcase/close-up.png';
import Clothes from 'assets/images/showcase/clothes.png';
import Fit from 'assets/images/showcase/fit.png';
import CloseUpMobile from 'assets/images/showcase/mobile-brand.png';
import FitMobile from 'assets/images/showcase/mobile-personal.png';
import ClothesMobile from 'assets/images/showcase/mobile-t-shirt.png';
import useScreenSize from 'hooks/useScreenSize';

export const Showcase = () => {
  const screenSize = useScreenSize();
  const navigate = useNavigate();

  const isMobileQuery = useMemo(() => {
    if (screenSize === 'sm' || screenSize === 'xs') {
      return true;
    }

    return false;
  }, [screenSize]);

  const defaultOptions = {
    reverse: false,
    max: 15,
    perspective: 1000,
    scale: 1,
    speed: 1000,
    transition: true,
    axis: null,
    reset: true,
    easing: 'cubic-bezier(.03,.98,.52,.99)',
  };

  return (
    <Container id={'showcase'}>
      {isMobileQuery ? <img src={BgMobile} alt={'black bg'} /> : <Bg />}

      <Wrapper>
        <div
          className={'card-wrapper'}
          onClick={() => navigate('/product-design')}
        >
          <Tilt
            style={isMobileQuery ? { width: '100%' } : {}}
            options={defaultOptions}
          >
            {!isMobileQuery ? (
              <div className={'button-wrapper'} tabIndex={-1}>
                <StyledButton color={'#fff'}>Product Design</StyledButton>
              </div>
            ) : undefined}

            <CardBlur
              borderRadius={isMobileQuery ? 10 : 30}
              fullWidth={isMobileQuery}
            >
              <FadeInSection>
                <div className={'card-inside'}>
                  <img src={isMobileQuery ? ClothesMobile : Clothes} />
                </div>
                {isMobileQuery ? (
                  <div className={'button-wrapper'} tabIndex={-1}>
                    <StyledButton color={'#fff'}>Product Design</StyledButton>
                  </div>
                ) : undefined}
              </FadeInSection>
            </CardBlur>
          </Tilt>
        </div>

        <div
          className={'card-wrapper'}
          onClick={() => navigate('/ui-ux-design')}
        >
          <Tilt
            style={isMobileQuery ? { width: '100%' } : {}}
            options={defaultOptions}
          >
            {!isMobileQuery ? (
              <div className={'button-wrapper'} tabIndex={-1}>
                <StyledButton color={'#D7C0FE'}>UI/UX Design</StyledButton>
              </div>
            ) : undefined}
            <CardBlur
              borderRadius={isMobileQuery ? 10 : 30}
              fullWidth={isMobileQuery}
            >
              <FadeInSection>
                <div className={'card-inside'}>
                  <img src={isMobileQuery ? FitMobile : Fit} />
                </div>
                {isMobileQuery ? (
                  <div className={'button-wrapper'} tabIndex={-1}>
                    <StyledButton color={isMobileQuery ? '#A8221F' : '#D7C0FE'}>
                      UI/UX Design
                    </StyledButton>
                  </div>
                ) : undefined}
              </FadeInSection>
            </CardBlur>
          </Tilt>
        </div>
        <div
          className={'card-wrapper'}
          onClick={() => navigate('/brand-identity')}
        >
          <Tilt
            style={isMobileQuery ? { width: '100%' } : {}}
            options={defaultOptions}
          >
            {!isMobileQuery ? (
              <div className={'button-wrapper'} tabIndex={-1}>
                <StyledButton color={'#fff'}>Brand Identity</StyledButton>
              </div>
            ) : undefined}
            <CardBlur
              borderRadius={isMobileQuery ? 10 : 30}
              fullWidth={isMobileQuery}
            >
              <FadeInSection>
                <div className={'card-inside'}>
                  <img src={isMobileQuery ? CloseUpMobile : CloseUp} />
                </div>
                {isMobileQuery ? (
                  <div className={'button-wrapper'} tabIndex={-1}>
                    <StyledButton color={'#fff'}>Brand Identity</StyledButton>
                  </div>
                ) : undefined}
              </FadeInSection>
            </CardBlur>
          </Tilt>
        </div>
      </Wrapper>
    </Container>
  );
};
